import { crudFor } from "./dataClient";
import { seedBanners } from "@/data/seed/banners";

export const bannersCrud = crudFor("banners", seedBanners);

export const bannersService = {
  async listByPlacement(placement) {
    const rows = await bannersCrud.list((q) =>
      q.eq("placement", placement).eq("is_active", true).order("sort_order")
    );
    return rows
      .filter((b) => b.placement === placement && b.is_active !== false)
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  },
};
